/**
 * Logo + nome + segmento de uma empresa na Central.
 *
 * Decisao nao obvia: a identidade visual vem de `useCompany().companies`
 * (a mesma fonte do cabecalho), cruzada pelo `companyId`. Se a linha vier
 * de uma empresa fora dessa lista, cai nas iniciais do nome que a propria
 * linha trouxe -- a empresa nunca some da tabela por falta de logo.
 */

import { CompanyLogo } from '../../../components/ui';
import type { CompanySummary } from '../../../types';

export type IdentidadeVisual = Pick<CompanySummary, 'id' | 'name' | 'segment' | 'logoInitials' | 'logoTone' | 'logoUrl'>;

function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter((p) => p.length > 0);
  const primeira = partes[0]?.charAt(0) ?? 'E';
  const segunda = partes.length > 1 ? partes[partes.length - 1]?.charAt(0) ?? '' : partes[0]?.charAt(1) ?? '';
  return `${primeira}${segunda}`.toUpperCase();
}

export function identidadeDaEmpresa(companyId: string, companies: readonly CompanySummary[], nomeFallback = 'Empresa'): IdentidadeVisual {
  const achada = companies.find((c) => c.id === companyId);
  if (achada !== undefined) {
    return achada;
  }
  return { id: companyId, name: nomeFallback, segment: '', logoInitials: iniciais(nomeFallback), logoTone: 1, logoUrl: null };
}

export function IdentidadeEmpresa({
  empresa,
  size = 'md',
  mostrarSegmento = true,
}: {
  readonly empresa: IdentidadeVisual;
  readonly size?: 'sm' | 'md' | 'lg';
  readonly mostrarSegmento?: boolean;
}): JSX.Element {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <CompanyLogo company={empresa} size={size} />
      <div className="min-w-0">
        <p className="truncate font-medium text-ink">{empresa.name}</p>
        {mostrarSegmento && empresa.segment !== '' ? <p className="truncate text-xs text-ink-subtle">{empresa.segment}</p> : null}
      </div>
    </div>
  );
}
